// PAMLayout.js
import React from "react";

import HUF from "./HUF";
import Citizen from "./Citizen";
import Categories from "./Categories";
import NonIndividualForeign from "./NonIndividualForeign";

function PAMLayout() {
  return (
    <div className="flex flex-col gap-8">
      <div className="grid gap-4 lg:grid-cols-2">
        <HUF />
        <div className="flex flex-col gap-4">
          <div className="p-4 bg-[#EAF4FA] lg:min-h-[613px] relative rounded-lg shadow-sm">
            <Citizen />
          </div>
          <Categories />
        </div>
      </div>
      <div className="w-full">
        <NonIndividualForeign />
      </div>
    </div>
  );
}

export default PAMLayout;